import React from 'react';
import { modules, type ModuleColor } from '../data/content';
const headerBg: Record<ModuleColor, string> = {
  blue: 'bg-blue-700',
  red: 'bg-red-700',
  amber: 'bg-amber-700',
  green: 'bg-green-700',
  purple: 'bg-violet-700',
  charcoal: 'bg-slate-600'
};
export function Modules() {
  return <section className="bg-blush/30 px-3 py-4 sm:px-6" data-id="element-102" data-mp="20wew6t8napsm">
      <div className="mx-auto max-w-2xl space-y-2" data-id="element-103" data-mp="20y9lskuv3631">
        {modules.map(mod => <article key={mod.title} className="overflow-hidden rounded-md border border-navy/10 bg-white shadow-sm" data-id="element-104" data-mp="147pdj0p71t5l">
            <h3 className={`px-2.5 py-1.5 text-xs font-extrabold uppercase leading-tight tracking-wide text-white sm:text-sm ${headerBg[mod.color]}`} data-id="element-105" data-mp="1d61b5moh9r7j">
              ✓ {mod.title}
            </h3>
            <p className="px-2.5 py-2 text-sm leading-snug sm:text-base" data-id="element-106" data-mp="2oky3b5fykwj4">{mod.body}</p>
          </article>)}
      </div>
    </section>;
}